module.exports = __webpack_public_path__ + "static/media/prinz-eugen-icon.38f6ce4d.png";